import PAGES from "@/seo/pages.json";

export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const BRAND = "PixelEdit Pro";
const HREFLANG = { en: "en", pt: "pt-BR" };

export const pageForPath = (pathname) => {
  const p = pathname.replace(/\/+$/, "") || "/";
  for (const [key, page] of Object.entries(PAGES))
    for (const [lang, path] of Object.entries(page.paths)) if (path === p) return { key, lang };
  return null;
};

const upsert = (selector, tag, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) { el = document.createElement(tag); document.head.appendChild(el); }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

export function applyHead(pathname, lang) {
  const match = pageForPath(pathname);
  document.documentElement.lang = HREFLANG[lang];
  document.head.querySelectorAll("link[data-seo]").forEach((l) => l.remove());
  if (window.gtag) window.gtag("event", "page_view", { page_path: pathname, page_location: window.location.href, page_title: match ? PAGES[match.key][lang].title : BRAND });
  if (!match) {
    document.title = BRAND;
    upsert('meta[name="robots"]', "meta", { name: "robots", content: "noindex, nofollow" });
    return;
  }
  const page = PAGES[match.key];
  const m = page[lang];
  document.title = m.title;
  upsert('meta[name="robots"]', "meta", { name: "robots", content: "index, follow, max-image-preview:large" });
  upsert('meta[name="description"]', "meta", { name: "description", content: m.description });
  upsert('meta[property="og:title"]', "meta", { property: "og:title", content: m.title });
  upsert('meta[property="og:description"]', "meta", { property: "og:description", content: m.description });
  upsert('meta[property="og:url"]', "meta", { property: "og:url", content: SITE_URL + page.paths[lang] });
  upsert('meta[property="og:locale"]', "meta", { property: "og:locale", content: lang === "pt" ? "pt_BR" : "en_US" });
  const add = (attrs) => { const l = document.createElement("link"); Object.entries({ ...attrs, "data-seo": "" }).forEach(([k, v]) => l.setAttribute(k, v)); document.head.appendChild(l); };
  add({ rel: "canonical", href: SITE_URL + page.paths[lang] });
  Object.entries(page.paths).forEach(([l, p]) => add({ rel: "alternate", hreflang: HREFLANG[l], href: SITE_URL + p }));
  add({ rel: "alternate", hreflang: "x-default", href: SITE_URL + page.paths.en });
}

export { PAGES };
